module.exports = {
    USD: 100,
    MYR: 25,
    THB: 3.2,
    SGD: 74,
    TWD: 3,
    HKD: 13,
    CNY: 15,
    IDR: 0.0071,
    VND: 0.0044,
    PHP: 2,
    LAK: 0.01,
    MMK: 0.08,
    BND: 73,
    INR: 1.5,
    EUR: 112,
    KHR: 0.025,
    TRY: 35,
    AUD: 71
};



// WEBPACK FOOTER //
// ./src/config/rate.js